/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectChangeOrderDetailsCommand } from '../../models/delete-project-change-order-details-command';
import { DeleteProjectChangeOrderDetailsCommandResult } from '../../models/delete-project-change-order-details-command-result';

export interface ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Params {
      body?: DeleteProjectChangeOrderDetailsCommand
}

export function apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectChangeOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectChangeOrderDetailsCommandResult>;
    })
  );
}

apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete.PATH = '/api/ProjectChangeOrder/DeleteProjectChangeOrderDetails';
